
import { Link } from 'react-router-dom';

export default function RecentWork() {
  const publications = [
    {
      title: 'The Mirror Effect',
      subtitle: 'Why AI Mimics Our Worst Habits',
      description: 'Bridging the Gap Between Technical AI Alignment and Risk Engineering',
      link: '/whitepaper'
    },
    {
      title: 'State of AI Regulation 2025',
      subtitle: 'The Crisis of Inconsistency',
      description: 'Navigating the Collision Between Federal Preemption, State Sovereignty, and Civil Rights',
      link: '/state-of-ai'
    },
    {
      title: 'AI Liability Framework',
      subtitle: 'The Mirror Effect and Product Defect Law',
      description: 'Legal Analysis of Behavioral Mimicry and Design Defects in Generative AI',
      link: '/ai-liability'
    },
    {
      title: 'Constitutional AI & Legal Accountability',
      subtitle: 'A Framework for Auditable Safety',
      description: 'Integrating Constitutional AI into the NIST AI Risk Management Framework',
      link: '/constitutional-ai'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-6" style={{ fontFamily: "'Inter', sans-serif" }}>
            Recent Publications
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Exploring the intersection of AI alignment, risk engineering, and regulatory frameworks
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {publications.map((pub, index) => (
            <div key={index} className="bg-slate-50 p-8 hover:shadow-xl transition-all duration-300 group border border-slate-200 hover:border-red-800">
              <h3 className="text-2xl font-bold text-slate-900 mb-3 group-hover:text-red-800 transition-colors duration-300">
                {pub.title}
              </h3>
              <h4 className="text-lg font-semibold text-slate-700 mb-4">
                {pub.subtitle}
              </h4>
              <p className="text-slate-600 mb-6 leading-relaxed">
                {pub.description}
              </p>
              <Link 
                to={pub.link}
                className="inline-flex items-center gap-2 text-red-800 hover:text-red-900 font-semibold transition-colors duration-300 cursor-pointer"
              >
                Read More
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link 
            to="/publications"
            className="bg-slate-900 hover:bg-slate-800 text-white px-8 py-4 text-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer inline-block"
          >
            View All Publications
          </Link>
        </div>
      </div>
    </section>
  );
}
